import React from 'react';
import {
  StackLayout,
  Button,
  ParagraphText,
  ImageMessage,
} from '@leagueplatform/genesis-core';
import exitWarning from 'assets/exit-warning.svg';
import { BaseModalContainer } from './common/base-modal.component';

interface ModalProps {
  title?: string;
  description?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  swapButtonPriority?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const UnsaveChangesWarningModal: React.FC<ModalProps> = ({
  title,
  description,
  cancelButtonText,
  confirmButtonText,
  swapButtonPriority = false,
  onClose,
  onConfirm,
}) => (
  <BaseModalContainer
    title={title}
    footer={
      <StackLayout
        orientation={{ '@initial': 'horizontal', '@mobile': 'vertical' }}
        spacing="$oneAndHalf"
        horizontalAlignment="stretch"
      >
        {cancelButtonText && (
          <Button
            onClick={onClose}
            priority={swapButtonPriority ? 'secondary' : 'primary'}
            css={{
              height: '$three',
              whiteSpace: 'nowrap',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: '$interactiveActionPrimary',
              '&:hover, &:active, &:focus': {
                backgroundColor: '$interactiveBackgroundHovered',
                color: '$interactiveActionHovered',
                textDecoration: 'none',
              },
            }}
          >
            {cancelButtonText}
          </Button>
        )}
        {confirmButtonText && (
          <Button
            onClick={onConfirm}
            priority={swapButtonPriority ? 'primary' : 'secondary'}
            css={{
              height: '$three',
              whiteSpace: 'nowrap',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: '$secondaryBackgroundDefault',
              '&:hover, &:active, &:focus': {
                backgroundColor: '$interactiveBackgroundHovered',
                color: '$interactiveActionHovered',
                textDecoration: 'none',
              },
            }}
          >
            {confirmButtonText}
          </Button>
        )}
      </StackLayout>
    }
  >
    <ImageMessage image={exitWarning}>
      <ParagraphText css={{ marginBottom: '$oneAndHalf', textAlign: 'center' }}>
        {description}
      </ParagraphText>
    </ImageMessage>
  </BaseModalContainer>
);
